import React, { useEffect, useState } from "react";
import CarritoCompras from "../components/CarritoCompras";
import Header from "../components/layout/Header";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { routes } from "../helpers/Routes";
import { useProductos } from "../hooks/useProductos";
import api from "../config/axios";

const PaySuccess = () => {
    const [transaction, setTransaction] = useState(null);
    const [openCart, setOpenCart] = useState(false);
    const [sendEmail, setSendEmail] = useState("");
    const { cart, orden, getOrden } = useProductos();
    const [city, setCity] = useState("");

    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const refPayco = searchParams.get('ref_payco');


    useEffect(() => {


        if (refPayco) {
            // Aquí puedes consultar el estado del pago usando la API de ePayco
            fetch(`https://secure.epayco.co/validation/v1/reference/${refPayco}`)
                .then((response) => response.json())
                .then((data) => {
                    setTransaction(data);
                })
                .catch((error) => {
                    console.error('Error al validar el pago:', error);
                    setTransaction(error);
                });
        }

    }, [location.search]);

    useEffect(() => {
        if (!orden && transaction?.data.x_id_factura) {
            getOrden(transaction?.data.x_id_factura)

        }
    }, [transaction, orden])

    let peso = cart?.map((item, idx) => {
        return item.cantidad * Number(item.peso.replace(" kg", ""))
    });
    let acum_cant = 0;
    cart?.map((item, idx) => {
        acum_cant = acum_cant + item.cantidad
    })

    useEffect(() => {
        if (orden) {
            fetch('https://api-v2.dev.mpr.mipaquete.com/getLocations', {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'session-tracker': 'a0c96ea6-b22d-4fb7-a278-850678d5429c',
                    'apikey': 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJfaWQiOiI2Nzk4ZWVkOTJiNDc2MzNlZWI4N2U4NjQiLCJuYW1lIjoiSm9yZ2UiLCJzdXJuYW1lIjoiR3VhcmRvIiwiZW1haWwiOiJkZWxpYXJvc2FybzExMkBnbWFpbC5jb20iLCJjZWxsUGhvbmUiOiIzMDA3NzgyODc3IiwiY3JlYXRlZEF0IjoiMjAyNS0wMS0yOFQxNDo1MTowNS4yMzdaIiwiZGF0ZSI6IjIwMjUtMDItMDYgMTE6MzU6MDIiLCJpYXQiOjE3Mzg4NTk3MDJ9.iEEyO9OX2bwHw2wzwbjfeyjJc3sjNYmOkMZmDCHO_H4'
                }
            }).then((response) => response.json()).then((data) => {
                for (let i = 0; i < data.length; i++) {
                    let queryLocation = orden?.description.split(" ")[2];

                    if (queryLocation.toUpperCase().includes(data[i]?.locationName.toUpperCase())) {
                        setCity(data[i]?.locationCode);
                    }
                }
            }).catch((error) => {
                console.error('Error al obtener las ciudades:', error);
            })
        }
    }, [orden])
    const processedTransactions = JSON.parse(localStorage.getItem("facturasProcesadas") || "[]");
    console.log( transaction?.data?.x_transaction_state,
        refPayco, orden?.name, city)
    useEffect(() => {
        if (
            transaction?.data?.x_transaction_state === "Aceptada" &&
            refPayco && orden?.name && city?.trim() !== ""
        ) {
            
            // Verificar si la transacción ya fue procesada

            console.log({ orden })
            fetch(`https://api-v2.dev.mpr.mipaquete.com/createSending`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'session-tracker': 'a0c96ea6-b22d-4fb7-a278-850678d5429c',
                    'apikey': 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJfaWQiOiI2Nzk4ZWVkOTJiNDc2MzNlZWI4N2U4NjQiLCJuYW1lIjoiSm9yZ2UiLCJzdXJuYW1lIjoiR3VhcmRvIiwiZW1haWwiOiJkZWxpYXJvc2FybzExMkBnbWFpbC5jb20iLCJjZWxsUGhvbmUiOiIzMDA3NzgyODc3IiwiY3JlYXRlZEF0IjoiMjAyNS0wMS0yOFQxNDo1MTowNS4yMzdaIiwiZGF0ZSI6IjIwMjUtMDItMDYgMTE6MzU6MDIiLCJpYXQiOjE3Mzg4NTk3MDJ9.iEEyO9OX2bwHw2wzwbjfeyjJc3sjNYmOkMZmDCHO_H4'
                },
                body: JSON.stringify({
                    sender: {
                        name: "Global",
                        surname: "Eco Business",
                        cellPhone: "3107336975",
                        prefix: "+57",
                        email: "globalecobusinesssas@gmail.com",
                        pickupAddress: "Calle 20 #32b 143",
                        nit: "1152456886",
                        nitType: "CC"
                    },
                    receiver: {
                        name: orden?.name,
                        surname: orden?.name,
                        email: orden?.email,
                        prefix: "+57",
                        cellPhone: orden?.telephone,
                        destinationAddress: orden?.description,
                        nit: "1152456886",
                        nitType: "CC"
                    },
                    productInformation: {
                        quantity: acum_cant,
                        width: 32,
                        large: 151,
                        height: 70,
                        weight: Math.round(peso[0]),
                        forbiddenProduct: true,
                        productReference: orden?.norden,
                        declaredValue: 10000
                    },
                    locate: {
                        originDaneCode: "11001000",
                        destinyDaneCode: `${city}`
                    },
                    channel: "Tienda de don pacho",
                    deliveryCompany: "5ca22d9587981510092322f6",
                    criteria: "price",
                    description: "Bicicleta",
                    comments: "comentarios adicionales",
                    paymentType: 102,
                    valueCollection: 10000,
                    requestPickup: false,
                    adminTransactionData: {
                        saleValue: 110000
                    }
                })
            })
                .then(response => response.json())
                .then(data => {
                    console.log("Envío creado:", data);
                    // Agregar la referencia a localStorage para evitar envíos duplicados
                    processedTransactions.push(orden?.norden ? orden?.norden : '');

                    setSendEmail(`<ul><li>Numero de orden: ${orden?.norden}</li><li>Nombre: ${orden?.name}</li><li>Cedula: ${orden?.cedula}</li><li>Telefono: ${orden?.telephone}</li><li>Ciudad:${orden?.description}</li><li>Productos: ${orden?.productos}</li><li>Total: ${new Intl.NumberFormat('es-CO', { style: 'currency', currency: 'COP' }).format(orden?.total)}</li></ul>`)
                })
                .catch(error => {
                    console.error("Error al crear el envío:", error);
                });
        } else {
            console.log("El envío ya ha sido procesado para esta referencia.");
        }

    }, [city, orden]);


    useEffect(() => {
        if (sendEmail?.trim() !== "") {
            fetch('https://api-javabicicletas-77db5a759140.herokuapp.com/api/ordenes/sendEmailConfirmation', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'session-tracker': 'a0c96ea6-b22d-4fb7-a278-850678d5429c',
                },
                body: JSON.stringify({
                    toEmail: orden?.email,
                    subject: "Confirmación de compra",
                    message: sendEmail,

                })
            }).then(response => response.json()).then(data => {
                localStorage.setItem("facturasProcesadas", JSON.stringify(processedTransactions));
                console.log("mensaje enviado por correo electronico", data);
            }).catch(error => {
                console.log("Error al enviar el correo:", error);
            })
        } else {
            console.log("no entra al sendemail")
        }
    }, [sendEmail]);

    const descuento = async () => {
        await Promise.all(
            cart?.map(async (item) => {
                await api.put(`/productos/${item?.id}`, {
                    id: item?.id,
                    cantidadDescuento: item?.cantidad
                });
            })
        )
    }

    useEffect(() => {
        if (transaction?.data?.x_transaction_state === "Aceptada") {
            api.put(`/ordenes/${orden?.norden}`, {
                id: orden?.norden
            }).then(response => console.log(response)).catch(error => console.log(error));

            descuento();
        }
    }, [])

    console.log(sendEmail)
    const handlePrint = () => {
        window.print();
    };


    return (
        <>
            <Header />
            <CarritoCompras setOpenCart={setOpenCart} openCart={openCart} />
            <div className="wrapper" style={{ margin: "100px auto", background: "#000000" }}>
                <div className="container-preview" style={{ flexDirection: "column", alignItems: "center", justifyContent: "center", width: "100%" }}>
                    <div className="receipt-container">
                        <h2 className="receipt-title">Transacción {transaction?.data.x_transaction_state}</h2>
                        <div className="receipt-content">
                            <table>
                                <tbody>
                                    <tr>
                                        <td>Empresa:</td>
                                        <td>{transaction?.data.x_business || "Sin información"}</td>
                                    </tr>
                                    <tr>
                                        <td>Valor:</td>
                                        <td>{transaction?.data.x_amount ? new Intl.NumberFormat('es-CO', { style: 'currency', currency: 'COP' }).format(transaction?.data.x_amount) : "Sin información"}</td>
                                    </tr>
                                    <tr>
                                        <td>Fecha y hora:</td>
                                        <td>{transaction?.data.x_fecha_transaccion || "Sin información"}</td>
                                    </tr>
                                    <tr>
                                        <td>Número de recibo:</td>
                                        <td>{transaction?.data.x_id_factura || "Sin información"}</td>
                                    </tr>
                                    <tr>
                                        <td>Descripción:</td>
                                        <td>{transaction?.data.x_description ? "Pago de " + transaction?.data.x_description : "Sin información"}</td>
                                    </tr>
                                    <tr>
                                        <td>Estado de transacción:</td>
                                        <td style={{ fontWeight: "bold", textTransform: "uppercase" }}>{transaction?.data.x_transaction_state || "Sin información"}</td>
                                    </tr>
                                    <tr>
                                        <td>Referencia ePayco:</td>
                                        <td>{transaction?.data.x_ref_payco || "Sin información"}</td>
                                    </tr>
                                    <tr>
                                        <td>IP origen:</td>
                                        <td>{transaction?.data.x_customer_ip || "Sin información"}</td>
                                    </tr>
                                    <tr>
                                        <td>Autorización CUS:</td>
                                        <td>{transaction?.data.x_approval_code || "Sin información"}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div className="receipt-actions">
                            {transaction?.data.x_transaction_state === "Aceptada" && (
                                <button className="print-button" onClick={handlePrint}>Imprimir o guardar</button>
                            )}
                            <Link to={routes.home} className="finalize-button">Regresar al comercio</Link>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default PaySuccess;